// extracted by mini-css-extract-plugin
export var wrapper = "PaperCanvas-module--wrapper--f0541";